import React, { FC, PropsWithChildren } from "react";
import style from "./style.scss";

export interface ThemeBuilderSectionLineProps {
    readonly label: string | undefined;
    readonly headingContent?: JSX.Element;
}

export const ThemeBuilderSectionLine: FC<PropsWithChildren<ThemeBuilderSectionLineProps>> = props => {

    return (
        <>
            <div className="widget-theme-builder-line">
                {props.label && <label className={style.sectionLineLabel}>{props.label}{props.headingContent}</label>}
                <div className={style.sectionLineContent}>
                    {props.children}
                </div>
            </div>
        </>
    );
};
